import { render, staticRenderFns } from "./cherrycreation.vue?vue&type=template&id=5fb75f57"
import script from "./cherrycreation.vue?vue&type=script&lang=js"
export * from "./cherrycreation.vue?vue&type=script&lang=js"
import style0 from "./cherrycreation.vue?vue&type=style&index=0&id=5fb75f57&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports